module.exports = __webpack_public_path__ + "img/logo_sad.cdb8b832.png";